/**
 * @generated SignedSource<<01632358ee643e3c70bf21e0e3e3fc29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useRegisterSessionMutation$variables = Record<PropertyKey, never>;
export type useRegisterSessionMutation$data = {
  readonly storeViewer: {
    readonly registerActivity: {
      readonly __typename: "StoreViewer";
    };
  } | null;
};
export type useRegisterSessionMutation = {
  response: useRegisterSessionMutation$data;
  variables: useRegisterSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "SESSION_STARTED"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRegisterSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreViewerMutation",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "StoreViewer",
            "kind": "LinkedField",
            "name": "registerActivity",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": "registerActivity(type:\"SESSION_STARTED\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRegisterSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreViewerMutation",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "StoreViewer",
            "kind": "LinkedField",
            "name": "registerActivity",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": "registerActivity(type:\"SESSION_STARTED\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66a735a8f7052e2040e1b50d0a4367f6",
    "id": null,
    "metadata": {},
    "name": "useRegisterSessionMutation",
    "operationKind": "mutation",
    "text": "mutation useRegisterSessionMutation {\n  storeViewer {\n    registerActivity(type: SESSION_STARTED) {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a21beb52991d5540bc9885ea82c4457f";

export default node;
